module.exports = __webpack_public_path__ + "img/dd.1ab016a7.png";